import React from "react";
import { Button, ButtonProps } from "components/Buttons";

type WarningButtonProps = Omit<ButtonProps, "color">;

export const WarningButton = (props: WarningButtonProps) => <Button {...props} color="warning" />;
